import { useState, useEffect } from 'react';
import { api } from '../lib/api.js';
import { todayStr } from '../lib/format.js';
import { clock } from '../lib/store-check.js';

// The day reports: one for all stores, then one per store that had readings.
// Written after 6:30pm from the day's stored readings, not from pictures.
export function StoreCheckReports() {
  const [day, setDay] = useState(() => todayStr());
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  useEffect(() => {
    setError('');
    api('GET', `/api/store-check/reports?day=${day}`).then(setData).catch((e) => { setData(null); setError(e.message || 'Could not load the report'); });
  }, [day]);
  return (
    <div className="space-y-3">
      <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
        <input type="date" value={day} max={todayStr()} aria-label="Report day" onChange={(e) => setDay(e.target.value || todayStr())}
          style={{ fontSize: 12, padding: '6px 8px', border: '1px solid var(--rule, #ddd)', borderRadius: 6 }} />
      </div>
      {error && <div className="card" style={{ color: '#b00020' }}>Error: {error}</div>}
      {data && data.reports.length === 0 && (
        <div className="card text-sm text-gray-500">
          {day === todayStr() ? 'Today’s report is written after 6:30pm, from the day’s checks.' : 'No report was written for this day.'}
        </div>
      )}
      {(data?.reports || []).map((r) => (
        <div key={r.location_id ?? 'all'} className="card" data-report={r.store}>
          <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8, alignItems: 'baseline', marginBottom: 6 }}>
            <div style={{ fontSize: 15, fontWeight: 700 }}>{r.store}</div>
            <div className="text-xs text-gray-500">
              {r.source?.read != null ? `${r.source.read} of ${r.source.total} pictures read · ` : ''}written {clock(r.written_at)}
            </div>
          </div>
          <div style={{ fontSize: 13, whiteSpace: 'pre-wrap', lineHeight: 1.5 }}>{r.body}</div>
        </div>
      ))}
    </div>
  );
}
